
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index_NI3B_6RlcMcQC3fcUBr_RmgvQZmWgEjQPq9_onR28oMeta } from "/opt/app-root/src/website/app/pages/index.vue?macro=true";
import { default as _91slug_93c94EtcD3lyFGSCRtoqiaviNJ7zygur9NPm7fqiSgifMMeta } from "/opt/app-root/src/website/app/pages/content-page/c/[slug].vue?macro=true";
import { default as _91slug_93tKKoMNRz53RkzF8u2ajzM3rjNKmHPgWVJSkTJWY8uekMeta } from "/opt/app-root/src/website/app/pages/landingpage/gameserver/[slug].vue?macro=true";
import { default as _91slug_934J_20RUSV_mvNpvtVML0tUaOA_mZR2IXaDSx57iwRTUMeta } from "/opt/app-root/src/website/app/pages/landingpage/subscription/[slug].vue?macro=true";
import { default as _91slug_93TQ_EJt_DXHlP2N1fptCizyWKoYHZQnGWKyGsAf9XHdoMeta } from "/opt/app-root/src/website/app/pages/landingpage/voiceserver/[slug].vue?macro=true";
import { default as indexHi9NIuHnXfcwRKv0XsqwFw9EMi87kvgZaXfnTnqnEXEMeta } from "/opt/app-root/src/website/variants/legacy/app/pages/account/payments/index.vue?macro=true";
import { default as indexmDppJKBUb0vX5Crmn009__VibZdn8XIbgKuchD7lsyoMeta } from "/opt/app-root/src/website/app/pages/account/recharge/index.vue?macro=true";
import { default as result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta } from "/opt/app-root/src/website/variants/legacy/app/pages/checkout/result.vue?macro=true";
import { default as callbackNpQ__RCtRYzh3e3zLMklu4eLCbQdsBSOUOoevO5vMNMMeta } from "/opt/app-root/src/website/variants/legacy/app/pages/nuxt/callback.vue?macro=true";
import { default as _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta } from "/opt/app-root/src/website/variants/legacy/app/pages/checkout/[planId]/step/[stepNumber].vue?macro=true";
import { default as _91slug_937O7C5sFckyxNCpKpEw2hU55YD8yNuVQAbFtjneaS00UMeta } from "/opt/app-root/src/website/app/pages/blog/[slug].vue?macro=true";
import { default as _91slug_93yEamAayfYD8pTTDuT3s12BgIuypvu3FvhstZHLlP1CwMeta } from "/opt/app-root/src/website/app/pages/news/[slug].vue?macro=true";
import { default as _91ticketId_93_ENkg_ET_nS3OaCDo0ExvXaMXtPmIHK8uW6wRL3x5awMeta } from "/opt/app-root/src/website/app/pages/support/[ticketId].vue?macro=true";
import { default as indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta } from "/opt/app-root/src/website/app/pages/debug/index.vue?macro=true";
import { default as indexbRw9SBxZlBkMlsyi9aGzNV_57kwDJGkraFXS94Gu2ocMeta } from "/opt/app-root/src/website/app/pages/lootpass/index.vue?macro=true";
import { default as indexbUsI8ZTOiTNGgQdx_3HPSloMW_NhCFvCERS6W1zYnckMeta } from "/opt/app-root/src/website/app/pages/news/index.vue?macro=true";
import { default as indexMkCycdtl_JjCrmp_M7srDRO2ZAVRrW_AGv1yIos0JXQMeta } from "/opt/app-root/src/website/app/pages/partner/index.vue?macro=true";
import { default as indexwDx9q12sAr29piTqQrjzKdc8jL7CP7UXqNxj3Iq2Mx4Meta } from "/opt/app-root/src/website/variants/legacy/app/pages/profile/index.vue?macro=true";
import { default as indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta } from "/opt/app-root/src/website/app/pages/register/index.vue?macro=true";
import { default as index4hkRRR5YsmCzyK0BATYUNo_N2DeBR9RdEc1_FUqh7zoMeta } from "/opt/app-root/src/website/app/pages/support/index.vue?macro=true";
import { default as indexV9gLKo3fojB2xfh_g_YRQgKXawLgnQF15Vr1RQ7brrgMeta } from "/opt/app-root/src/website/app/pages/sustainability/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/app-root/src/website/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: index_NI3B_6RlcMcQC3fcUBr_RmgvQZmWgEjQPq9_onR28oMeta?.name ?? "index" }))
  },
  {
    name: "content-page-c-slug___de",
    path: "/de/c/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/content-page/c/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93c94EtcD3lyFGSCRtoqiaviNJ7zygur9NPm7fqiSgifMMeta?.name ?? "content-page-c-slug___de" }))
  },
  {
    name: "content-page-c-slug___en",
    path: "/en/c/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/content-page/c/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93c94EtcD3lyFGSCRtoqiaviNJ7zygur9NPm7fqiSgifMMeta?.name ?? "content-page-c-slug___en" }))
  },
  {
    name: "content-page-c-slug___fr",
    path: "/fr/c/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/content-page/c/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93c94EtcD3lyFGSCRtoqiaviNJ7zygur9NPm7fqiSgifMMeta?.name ?? "content-page-c-slug___fr" }))
  },
  {
    name: "content-page-c-slug___it",
    path: "/it/c/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/content-page/c/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93c94EtcD3lyFGSCRtoqiaviNJ7zygur9NPm7fqiSgifMMeta?.name ?? "content-page-c-slug___it" }))
  },
  {
    name: "content-page-c-slug___pl",
    path: "/pl/c/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/content-page/c/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93c94EtcD3lyFGSCRtoqiaviNJ7zygur9NPm7fqiSgifMMeta?.name ?? "content-page-c-slug___pl" }))
  },
  {
    name: "content-page-c-slug___es",
    path: "/es/c/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/content-page/c/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93c94EtcD3lyFGSCRtoqiaviNJ7zygur9NPm7fqiSgifMMeta?.name ?? "content-page-c-slug___es" }))
  },
  {
    name: "content-page-c-slug___pt",
    path: "/pt/c/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/content-page/c/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93c94EtcD3lyFGSCRtoqiaviNJ7zygur9NPm7fqiSgifMMeta?.name ?? "content-page-c-slug___pt" }))
  },
  {
    name: "content-page-c-slug___nl",
    path: "/nl/c/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/content-page/c/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93c94EtcD3lyFGSCRtoqiaviNJ7zygur9NPm7fqiSgifMMeta?.name ?? "content-page-c-slug___nl" }))
  },
  {
    name: "content-page-c-slug___ja",
    path: "/ja/c/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/content-page/c/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93c94EtcD3lyFGSCRtoqiaviNJ7zygur9NPm7fqiSgifMMeta?.name ?? "content-page-c-slug___ja" }))
  },
  {
    name: "content-page-c-slug___zh",
    path: "/zh/c/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/content-page/c/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93c94EtcD3lyFGSCRtoqiaviNJ7zygur9NPm7fqiSgifMMeta?.name ?? "content-page-c-slug___zh" }))
  },
  {
    name: "landingpage-gameserver-slug___de",
    path: "/de/gameserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/gameserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93tKKoMNRz53RkzF8u2ajzM3rjNKmHPgWVJSkTJWY8uekMeta?.name ?? "landingpage-gameserver-slug___de" }))
  },
  {
    name: "landingpage-gameserver-slug___en",
    path: "/en/gameserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/gameserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93tKKoMNRz53RkzF8u2ajzM3rjNKmHPgWVJSkTJWY8uekMeta?.name ?? "landingpage-gameserver-slug___en" }))
  },
  {
    name: "landingpage-gameserver-slug___fr",
    path: "/fr/serveur-de-jeu/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/gameserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93tKKoMNRz53RkzF8u2ajzM3rjNKmHPgWVJSkTJWY8uekMeta?.name ?? "landingpage-gameserver-slug___fr" }))
  },
  {
    name: "landingpage-gameserver-slug___it",
    path: "/it/server-di-gioco/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/gameserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93tKKoMNRz53RkzF8u2ajzM3rjNKmHPgWVJSkTJWY8uekMeta?.name ?? "landingpage-gameserver-slug___it" }))
  },
  {
    name: "landingpage-gameserver-slug___pl",
    path: "/pl/serwery-gier/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/gameserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93tKKoMNRz53RkzF8u2ajzM3rjNKmHPgWVJSkTJWY8uekMeta?.name ?? "landingpage-gameserver-slug___pl" }))
  },
  {
    name: "landingpage-gameserver-slug___es",
    path: "/es/gameserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/gameserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93tKKoMNRz53RkzF8u2ajzM3rjNKmHPgWVJSkTJWY8uekMeta?.name ?? "landingpage-gameserver-slug___es" }))
  },
  {
    name: "landingpage-gameserver-slug___pt",
    path: "/pt/servidor-de-jogos/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/gameserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93tKKoMNRz53RkzF8u2ajzM3rjNKmHPgWVJSkTJWY8uekMeta?.name ?? "landingpage-gameserver-slug___pt" }))
  },
  {
    name: "landingpage-gameserver-slug___nl",
    path: "/nl/gameserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/gameserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93tKKoMNRz53RkzF8u2ajzM3rjNKmHPgWVJSkTJWY8uekMeta?.name ?? "landingpage-gameserver-slug___nl" }))
  },
  {
    name: "landingpage-gameserver-slug___ja",
    path: "/ja/gameserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/gameserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93tKKoMNRz53RkzF8u2ajzM3rjNKmHPgWVJSkTJWY8uekMeta?.name ?? "landingpage-gameserver-slug___ja" }))
  },
  {
    name: "landingpage-gameserver-slug___zh",
    path: "/zh/gameserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/gameserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93tKKoMNRz53RkzF8u2ajzM3rjNKmHPgWVJSkTJWY8uekMeta?.name ?? "landingpage-gameserver-slug___zh" }))
  },
  {
    name: "landingpage-subscription-slug___de",
    path: "/de/get/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/subscription/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_934J_20RUSV_mvNpvtVML0tUaOA_mZR2IXaDSx57iwRTUMeta?.name ?? "landingpage-subscription-slug___de" }))
  },
  {
    name: "landingpage-subscription-slug___en",
    path: "/en/get/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/subscription/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_934J_20RUSV_mvNpvtVML0tUaOA_mZR2IXaDSx57iwRTUMeta?.name ?? "landingpage-subscription-slug___en" }))
  },
  {
    name: "landingpage-subscription-slug___fr",
    path: "/fr/get/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/subscription/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_934J_20RUSV_mvNpvtVML0tUaOA_mZR2IXaDSx57iwRTUMeta?.name ?? "landingpage-subscription-slug___fr" }))
  },
  {
    name: "landingpage-subscription-slug___it",
    path: "/it/get/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/subscription/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_934J_20RUSV_mvNpvtVML0tUaOA_mZR2IXaDSx57iwRTUMeta?.name ?? "landingpage-subscription-slug___it" }))
  },
  {
    name: "landingpage-subscription-slug___pl",
    path: "/pl/get/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/subscription/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_934J_20RUSV_mvNpvtVML0tUaOA_mZR2IXaDSx57iwRTUMeta?.name ?? "landingpage-subscription-slug___pl" }))
  },
  {
    name: "landingpage-subscription-slug___es",
    path: "/es/get/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/subscription/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_934J_20RUSV_mvNpvtVML0tUaOA_mZR2IXaDSx57iwRTUMeta?.name ?? "landingpage-subscription-slug___es" }))
  },
  {
    name: "landingpage-subscription-slug___pt",
    path: "/pt/get/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/subscription/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_934J_20RUSV_mvNpvtVML0tUaOA_mZR2IXaDSx57iwRTUMeta?.name ?? "landingpage-subscription-slug___pt" }))
  },
  {
    name: "landingpage-subscription-slug___nl",
    path: "/nl/get/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/subscription/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_934J_20RUSV_mvNpvtVML0tUaOA_mZR2IXaDSx57iwRTUMeta?.name ?? "landingpage-subscription-slug___nl" }))
  },
  {
    name: "landingpage-subscription-slug___ja",
    path: "/ja/get/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/subscription/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_934J_20RUSV_mvNpvtVML0tUaOA_mZR2IXaDSx57iwRTUMeta?.name ?? "landingpage-subscription-slug___ja" }))
  },
  {
    name: "landingpage-subscription-slug___zh",
    path: "/zh/get/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/subscription/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_934J_20RUSV_mvNpvtVML0tUaOA_mZR2IXaDSx57iwRTUMeta?.name ?? "landingpage-subscription-slug___zh" }))
  },
  {
    name: "landingpage-voiceserver-slug___de",
    path: "/de/voiceserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/voiceserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93TQ_EJt_DXHlP2N1fptCizyWKoYHZQnGWKyGsAf9XHdoMeta?.name ?? "landingpage-voiceserver-slug___de" }))
  },
  {
    name: "landingpage-voiceserver-slug___en",
    path: "/en/voiceserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/voiceserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93TQ_EJt_DXHlP2N1fptCizyWKoYHZQnGWKyGsAf9XHdoMeta?.name ?? "landingpage-voiceserver-slug___en" }))
  },
  {
    name: "landingpage-voiceserver-slug___fr",
    path: "/fr/serveur-de-jeu/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/voiceserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93TQ_EJt_DXHlP2N1fptCizyWKoYHZQnGWKyGsAf9XHdoMeta?.name ?? "landingpage-voiceserver-slug___fr" }))
  },
  {
    name: "landingpage-voiceserver-slug___it",
    path: "/it/server-di-voce/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/voiceserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93TQ_EJt_DXHlP2N1fptCizyWKoYHZQnGWKyGsAf9XHdoMeta?.name ?? "landingpage-voiceserver-slug___it" }))
  },
  {
    name: "landingpage-voiceserver-slug___pl",
    path: "/pl/serwery-gier/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/voiceserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93TQ_EJt_DXHlP2N1fptCizyWKoYHZQnGWKyGsAf9XHdoMeta?.name ?? "landingpage-voiceserver-slug___pl" }))
  },
  {
    name: "landingpage-voiceserver-slug___es",
    path: "/es/voiceserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/voiceserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93TQ_EJt_DXHlP2N1fptCizyWKoYHZQnGWKyGsAf9XHdoMeta?.name ?? "landingpage-voiceserver-slug___es" }))
  },
  {
    name: "landingpage-voiceserver-slug___pt",
    path: "/pt/voiceserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/voiceserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93TQ_EJt_DXHlP2N1fptCizyWKoYHZQnGWKyGsAf9XHdoMeta?.name ?? "landingpage-voiceserver-slug___pt" }))
  },
  {
    name: "landingpage-voiceserver-slug___nl",
    path: "/nl/voiceserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/voiceserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93TQ_EJt_DXHlP2N1fptCizyWKoYHZQnGWKyGsAf9XHdoMeta?.name ?? "landingpage-voiceserver-slug___nl" }))
  },
  {
    name: "landingpage-voiceserver-slug___ja",
    path: "/ja/voiceserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/voiceserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93TQ_EJt_DXHlP2N1fptCizyWKoYHZQnGWKyGsAf9XHdoMeta?.name ?? "landingpage-voiceserver-slug___ja" }))
  },
  {
    name: "landingpage-voiceserver-slug___zh",
    path: "/zh/voiceserver/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/landingpage/voiceserver/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93TQ_EJt_DXHlP2N1fptCizyWKoYHZQnGWKyGsAf9XHdoMeta?.name ?? "landingpage-voiceserver-slug___zh" }))
  },
  {
    name: "account-payments___de",
    path: "/de/account/payments",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/account/payments/index.vue").then((m) => Object.assign(m.default, { __name: indexHi9NIuHnXfcwRKv0XsqwFw9EMi87kvgZaXfnTnqnEXEMeta?.name ?? "account-payments___de" }))
  },
  {
    name: "account-payments___en",
    path: "/en/account/payments",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/account/payments/index.vue").then((m) => Object.assign(m.default, { __name: indexHi9NIuHnXfcwRKv0XsqwFw9EMi87kvgZaXfnTnqnEXEMeta?.name ?? "account-payments___en" }))
  },
  {
    name: "account-payments___fr",
    path: "/fr/account/payments",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/account/payments/index.vue").then((m) => Object.assign(m.default, { __name: indexHi9NIuHnXfcwRKv0XsqwFw9EMi87kvgZaXfnTnqnEXEMeta?.name ?? "account-payments___fr" }))
  },
  {
    name: "account-payments___it",
    path: "/it/account/payments",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/account/payments/index.vue").then((m) => Object.assign(m.default, { __name: indexHi9NIuHnXfcwRKv0XsqwFw9EMi87kvgZaXfnTnqnEXEMeta?.name ?? "account-payments___it" }))
  },
  {
    name: "account-payments___pl",
    path: "/pl/account/payments",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/account/payments/index.vue").then((m) => Object.assign(m.default, { __name: indexHi9NIuHnXfcwRKv0XsqwFw9EMi87kvgZaXfnTnqnEXEMeta?.name ?? "account-payments___pl" }))
  },
  {
    name: "account-payments___es",
    path: "/es/account/payments",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/account/payments/index.vue").then((m) => Object.assign(m.default, { __name: indexHi9NIuHnXfcwRKv0XsqwFw9EMi87kvgZaXfnTnqnEXEMeta?.name ?? "account-payments___es" }))
  },
  {
    name: "account-payments___pt",
    path: "/pt/account/payments",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/account/payments/index.vue").then((m) => Object.assign(m.default, { __name: indexHi9NIuHnXfcwRKv0XsqwFw9EMi87kvgZaXfnTnqnEXEMeta?.name ?? "account-payments___pt" }))
  },
  {
    name: "account-payments___nl",
    path: "/nl/account/payments",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/account/payments/index.vue").then((m) => Object.assign(m.default, { __name: indexHi9NIuHnXfcwRKv0XsqwFw9EMi87kvgZaXfnTnqnEXEMeta?.name ?? "account-payments___nl" }))
  },
  {
    name: "account-payments___ja",
    path: "/ja/account/payments",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/account/payments/index.vue").then((m) => Object.assign(m.default, { __name: indexHi9NIuHnXfcwRKv0XsqwFw9EMi87kvgZaXfnTnqnEXEMeta?.name ?? "account-payments___ja" }))
  },
  {
    name: "account-payments___zh",
    path: "/zh/account/payments",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/account/payments/index.vue").then((m) => Object.assign(m.default, { __name: indexHi9NIuHnXfcwRKv0XsqwFw9EMi87kvgZaXfnTnqnEXEMeta?.name ?? "account-payments___zh" }))
  },
  {
    name: "account-recharge___de",
    path: "/de/account/recharge",
    component: () => import("/opt/app-root/src/website/app/pages/account/recharge/index.vue").then((m) => Object.assign(m.default, { __name: indexmDppJKBUb0vX5Crmn009__VibZdn8XIbgKuchD7lsyoMeta?.name ?? "account-recharge___de" }))
  },
  {
    name: "account-recharge___en",
    path: "/en/account/recharge",
    component: () => import("/opt/app-root/src/website/app/pages/account/recharge/index.vue").then((m) => Object.assign(m.default, { __name: indexmDppJKBUb0vX5Crmn009__VibZdn8XIbgKuchD7lsyoMeta?.name ?? "account-recharge___en" }))
  },
  {
    name: "account-recharge___fr",
    path: "/fr/account/recharge",
    component: () => import("/opt/app-root/src/website/app/pages/account/recharge/index.vue").then((m) => Object.assign(m.default, { __name: indexmDppJKBUb0vX5Crmn009__VibZdn8XIbgKuchD7lsyoMeta?.name ?? "account-recharge___fr" }))
  },
  {
    name: "account-recharge___it",
    path: "/it/account/recharge",
    component: () => import("/opt/app-root/src/website/app/pages/account/recharge/index.vue").then((m) => Object.assign(m.default, { __name: indexmDppJKBUb0vX5Crmn009__VibZdn8XIbgKuchD7lsyoMeta?.name ?? "account-recharge___it" }))
  },
  {
    name: "account-recharge___pl",
    path: "/pl/account/recharge",
    component: () => import("/opt/app-root/src/website/app/pages/account/recharge/index.vue").then((m) => Object.assign(m.default, { __name: indexmDppJKBUb0vX5Crmn009__VibZdn8XIbgKuchD7lsyoMeta?.name ?? "account-recharge___pl" }))
  },
  {
    name: "account-recharge___es",
    path: "/es/account/recharge",
    component: () => import("/opt/app-root/src/website/app/pages/account/recharge/index.vue").then((m) => Object.assign(m.default, { __name: indexmDppJKBUb0vX5Crmn009__VibZdn8XIbgKuchD7lsyoMeta?.name ?? "account-recharge___es" }))
  },
  {
    name: "account-recharge___pt",
    path: "/pt/account/recharge",
    component: () => import("/opt/app-root/src/website/app/pages/account/recharge/index.vue").then((m) => Object.assign(m.default, { __name: indexmDppJKBUb0vX5Crmn009__VibZdn8XIbgKuchD7lsyoMeta?.name ?? "account-recharge___pt" }))
  },
  {
    name: "account-recharge___nl",
    path: "/nl/account/recharge",
    component: () => import("/opt/app-root/src/website/app/pages/account/recharge/index.vue").then((m) => Object.assign(m.default, { __name: indexmDppJKBUb0vX5Crmn009__VibZdn8XIbgKuchD7lsyoMeta?.name ?? "account-recharge___nl" }))
  },
  {
    name: "account-recharge___ja",
    path: "/ja/account/recharge",
    component: () => import("/opt/app-root/src/website/app/pages/account/recharge/index.vue").then((m) => Object.assign(m.default, { __name: indexmDppJKBUb0vX5Crmn009__VibZdn8XIbgKuchD7lsyoMeta?.name ?? "account-recharge___ja" }))
  },
  {
    name: "account-recharge___zh",
    path: "/zh/account/recharge",
    component: () => import("/opt/app-root/src/website/app/pages/account/recharge/index.vue").then((m) => Object.assign(m.default, { __name: indexmDppJKBUb0vX5Crmn009__VibZdn8XIbgKuchD7lsyoMeta?.name ?? "account-recharge___zh" }))
  },
  {
    name: "checkout-result___de",
    path: "/de/checkout/result",
    meta: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/result.vue").then((m) => Object.assign(m.default, { __name: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta?.name ?? "checkout-result___de" }))
  },
  {
    name: "checkout-result___en",
    path: "/en/checkout/result",
    meta: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/result.vue").then((m) => Object.assign(m.default, { __name: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta?.name ?? "checkout-result___en" }))
  },
  {
    name: "checkout-result___fr",
    path: "/fr/checkout/result",
    meta: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/result.vue").then((m) => Object.assign(m.default, { __name: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta?.name ?? "checkout-result___fr" }))
  },
  {
    name: "checkout-result___it",
    path: "/it/checkout/result",
    meta: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/result.vue").then((m) => Object.assign(m.default, { __name: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta?.name ?? "checkout-result___it" }))
  },
  {
    name: "checkout-result___pl",
    path: "/pl/checkout/result",
    meta: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/result.vue").then((m) => Object.assign(m.default, { __name: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta?.name ?? "checkout-result___pl" }))
  },
  {
    name: "checkout-result___es",
    path: "/es/checkout/result",
    meta: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/result.vue").then((m) => Object.assign(m.default, { __name: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta?.name ?? "checkout-result___es" }))
  },
  {
    name: "checkout-result___pt",
    path: "/pt/checkout/result",
    meta: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/result.vue").then((m) => Object.assign(m.default, { __name: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta?.name ?? "checkout-result___pt" }))
  },
  {
    name: "checkout-result___nl",
    path: "/nl/checkout/result",
    meta: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/result.vue").then((m) => Object.assign(m.default, { __name: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta?.name ?? "checkout-result___nl" }))
  },
  {
    name: "checkout-result___ja",
    path: "/ja/checkout/result",
    meta: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/result.vue").then((m) => Object.assign(m.default, { __name: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta?.name ?? "checkout-result___ja" }))
  },
  {
    name: "checkout-result___zh",
    path: "/zh/checkout/result",
    meta: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/result.vue").then((m) => Object.assign(m.default, { __name: result_6Xj_BUyfleCQKOJVLxoaMaPaftJOUPCQKdsPCTADTYMeta?.name ?? "checkout-result___zh" }))
  },
  {
    name: "nuxt-callback",
    path: "/nuxt/callback",
    meta: callbackNpQ__RCtRYzh3e3zLMklu4eLCbQdsBSOUOoevO5vMNMMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/nuxt/callback.vue").then((m) => Object.assign(m.default, { __name: callbackNpQ__RCtRYzh3e3zLMklu4eLCbQdsBSOUOoevO5vMNMMeta?.name ?? "nuxt-callback" }))
  },
  {
    name: "checkout-planId-step-stepNumber___de",
    path: "/de/checkout/:planId()/step/:stepNumber()",
    meta: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/[planId]/step/[stepNumber].vue").then((m) => Object.assign(m.default, { __name: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta?.name ?? "checkout-planId-step-stepNumber___de" }))
  },
  {
    name: "checkout-planId-step-stepNumber___en",
    path: "/en/checkout/:planId()/step/:stepNumber()",
    meta: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/[planId]/step/[stepNumber].vue").then((m) => Object.assign(m.default, { __name: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta?.name ?? "checkout-planId-step-stepNumber___en" }))
  },
  {
    name: "checkout-planId-step-stepNumber___fr",
    path: "/fr/checkout/:planId()/step/:stepNumber()",
    meta: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/[planId]/step/[stepNumber].vue").then((m) => Object.assign(m.default, { __name: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta?.name ?? "checkout-planId-step-stepNumber___fr" }))
  },
  {
    name: "checkout-planId-step-stepNumber___it",
    path: "/it/checkout/:planId()/step/:stepNumber()",
    meta: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/[planId]/step/[stepNumber].vue").then((m) => Object.assign(m.default, { __name: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta?.name ?? "checkout-planId-step-stepNumber___it" }))
  },
  {
    name: "checkout-planId-step-stepNumber___pl",
    path: "/pl/checkout/:planId()/step/:stepNumber()",
    meta: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/[planId]/step/[stepNumber].vue").then((m) => Object.assign(m.default, { __name: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta?.name ?? "checkout-planId-step-stepNumber___pl" }))
  },
  {
    name: "checkout-planId-step-stepNumber___es",
    path: "/es/checkout/:planId()/step/:stepNumber()",
    meta: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/[planId]/step/[stepNumber].vue").then((m) => Object.assign(m.default, { __name: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta?.name ?? "checkout-planId-step-stepNumber___es" }))
  },
  {
    name: "checkout-planId-step-stepNumber___pt",
    path: "/pt/checkout/:planId()/step/:stepNumber()",
    meta: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/[planId]/step/[stepNumber].vue").then((m) => Object.assign(m.default, { __name: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta?.name ?? "checkout-planId-step-stepNumber___pt" }))
  },
  {
    name: "checkout-planId-step-stepNumber___nl",
    path: "/nl/checkout/:planId()/step/:stepNumber()",
    meta: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/[planId]/step/[stepNumber].vue").then((m) => Object.assign(m.default, { __name: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta?.name ?? "checkout-planId-step-stepNumber___nl" }))
  },
  {
    name: "checkout-planId-step-stepNumber___ja",
    path: "/ja/checkout/:planId()/step/:stepNumber()",
    meta: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/[planId]/step/[stepNumber].vue").then((m) => Object.assign(m.default, { __name: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta?.name ?? "checkout-planId-step-stepNumber___ja" }))
  },
  {
    name: "checkout-planId-step-stepNumber___zh",
    path: "/zh/checkout/:planId()/step/:stepNumber()",
    meta: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta || {},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/checkout/[planId]/step/[stepNumber].vue").then((m) => Object.assign(m.default, { __name: _91stepNumber_93c0kDRDrSWlkkvBCE3BVJgqOrweJ4mm19f6fSXlzcgYgMeta?.name ?? "checkout-planId-step-stepNumber___zh" }))
  },
  {
    name: "blog-slug___de",
    path: "/de/blog/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/blog/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_937O7C5sFckyxNCpKpEw2hU55YD8yNuVQAbFtjneaS00UMeta?.name ?? "blog-slug___de" }))
  },
  {
    name: "blog-slug___en",
    path: "/en/blog/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/blog/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_937O7C5sFckyxNCpKpEw2hU55YD8yNuVQAbFtjneaS00UMeta?.name ?? "blog-slug___en" }))
  },
  {
    name: "blog-slug___fr",
    path: "/fr/blog/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/blog/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_937O7C5sFckyxNCpKpEw2hU55YD8yNuVQAbFtjneaS00UMeta?.name ?? "blog-slug___fr" }))
  },
  {
    name: "blog-slug___it",
    path: "/it/blog/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/blog/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_937O7C5sFckyxNCpKpEw2hU55YD8yNuVQAbFtjneaS00UMeta?.name ?? "blog-slug___it" }))
  },
  {
    name: "blog-slug___pl",
    path: "/pl/blog/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/blog/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_937O7C5sFckyxNCpKpEw2hU55YD8yNuVQAbFtjneaS00UMeta?.name ?? "blog-slug___pl" }))
  },
  {
    name: "blog-slug___es",
    path: "/es/blog/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/blog/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_937O7C5sFckyxNCpKpEw2hU55YD8yNuVQAbFtjneaS00UMeta?.name ?? "blog-slug___es" }))
  },
  {
    name: "blog-slug___pt",
    path: "/pt/blog/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/blog/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_937O7C5sFckyxNCpKpEw2hU55YD8yNuVQAbFtjneaS00UMeta?.name ?? "blog-slug___pt" }))
  },
  {
    name: "blog-slug___nl",
    path: "/nl/blog/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/blog/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_937O7C5sFckyxNCpKpEw2hU55YD8yNuVQAbFtjneaS00UMeta?.name ?? "blog-slug___nl" }))
  },
  {
    name: "blog-slug___ja",
    path: "/ja/blog/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/blog/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_937O7C5sFckyxNCpKpEw2hU55YD8yNuVQAbFtjneaS00UMeta?.name ?? "blog-slug___ja" }))
  },
  {
    name: "blog-slug___zh",
    path: "/zh/blog/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/blog/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_937O7C5sFckyxNCpKpEw2hU55YD8yNuVQAbFtjneaS00UMeta?.name ?? "blog-slug___zh" }))
  },
  {
    name: "news-slug___de",
    path: "/de/news/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/news/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93yEamAayfYD8pTTDuT3s12BgIuypvu3FvhstZHLlP1CwMeta?.name ?? "news-slug___de" }))
  },
  {
    name: "news-slug___en",
    path: "/en/news/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/news/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93yEamAayfYD8pTTDuT3s12BgIuypvu3FvhstZHLlP1CwMeta?.name ?? "news-slug___en" }))
  },
  {
    name: "news-slug___fr",
    path: "/fr/news/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/news/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93yEamAayfYD8pTTDuT3s12BgIuypvu3FvhstZHLlP1CwMeta?.name ?? "news-slug___fr" }))
  },
  {
    name: "news-slug___it",
    path: "/it/news/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/news/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93yEamAayfYD8pTTDuT3s12BgIuypvu3FvhstZHLlP1CwMeta?.name ?? "news-slug___it" }))
  },
  {
    name: "news-slug___pl",
    path: "/pl/news/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/news/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93yEamAayfYD8pTTDuT3s12BgIuypvu3FvhstZHLlP1CwMeta?.name ?? "news-slug___pl" }))
  },
  {
    name: "news-slug___es",
    path: "/es/news/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/news/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93yEamAayfYD8pTTDuT3s12BgIuypvu3FvhstZHLlP1CwMeta?.name ?? "news-slug___es" }))
  },
  {
    name: "news-slug___pt",
    path: "/pt/news/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/news/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93yEamAayfYD8pTTDuT3s12BgIuypvu3FvhstZHLlP1CwMeta?.name ?? "news-slug___pt" }))
  },
  {
    name: "news-slug___nl",
    path: "/nl/news/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/news/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93yEamAayfYD8pTTDuT3s12BgIuypvu3FvhstZHLlP1CwMeta?.name ?? "news-slug___nl" }))
  },
  {
    name: "news-slug___ja",
    path: "/ja/news/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/news/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93yEamAayfYD8pTTDuT3s12BgIuypvu3FvhstZHLlP1CwMeta?.name ?? "news-slug___ja" }))
  },
  {
    name: "news-slug___zh",
    path: "/zh/news/:slug()",
    component: () => import("/opt/app-root/src/website/app/pages/news/[slug].vue").then((m) => Object.assign(m.default, { __name: _91slug_93yEamAayfYD8pTTDuT3s12BgIuypvu3FvhstZHLlP1CwMeta?.name ?? "news-slug___zh" }))
  },
  {
    name: "support-ticketId___de",
    path: "/de/support/:ticketId()",
    component: () => import("/opt/app-root/src/website/app/pages/support/[ticketId].vue").then((m) => Object.assign(m.default, { __name: _91ticketId_93_ENkg_ET_nS3OaCDo0ExvXaMXtPmIHK8uW6wRL3x5awMeta?.name ?? "support-ticketId___de" }))
  },
  {
    name: "support-ticketId___en",
    path: "/en/support/:ticketId()",
    component: () => import("/opt/app-root/src/website/app/pages/support/[ticketId].vue").then((m) => Object.assign(m.default, { __name: _91ticketId_93_ENkg_ET_nS3OaCDo0ExvXaMXtPmIHK8uW6wRL3x5awMeta?.name ?? "support-ticketId___en" }))
  },
  {
    name: "support-ticketId___fr",
    path: "/fr/support/:ticketId()",
    component: () => import("/opt/app-root/src/website/app/pages/support/[ticketId].vue").then((m) => Object.assign(m.default, { __name: _91ticketId_93_ENkg_ET_nS3OaCDo0ExvXaMXtPmIHK8uW6wRL3x5awMeta?.name ?? "support-ticketId___fr" }))
  },
  {
    name: "support-ticketId___it",
    path: "/it/support/:ticketId()",
    component: () => import("/opt/app-root/src/website/app/pages/support/[ticketId].vue").then((m) => Object.assign(m.default, { __name: _91ticketId_93_ENkg_ET_nS3OaCDo0ExvXaMXtPmIHK8uW6wRL3x5awMeta?.name ?? "support-ticketId___it" }))
  },
  {
    name: "support-ticketId___pl",
    path: "/pl/support/:ticketId()",
    component: () => import("/opt/app-root/src/website/app/pages/support/[ticketId].vue").then((m) => Object.assign(m.default, { __name: _91ticketId_93_ENkg_ET_nS3OaCDo0ExvXaMXtPmIHK8uW6wRL3x5awMeta?.name ?? "support-ticketId___pl" }))
  },
  {
    name: "support-ticketId___es",
    path: "/es/support/:ticketId()",
    component: () => import("/opt/app-root/src/website/app/pages/support/[ticketId].vue").then((m) => Object.assign(m.default, { __name: _91ticketId_93_ENkg_ET_nS3OaCDo0ExvXaMXtPmIHK8uW6wRL3x5awMeta?.name ?? "support-ticketId___es" }))
  },
  {
    name: "support-ticketId___pt",
    path: "/pt/support/:ticketId()",
    component: () => import("/opt/app-root/src/website/app/pages/support/[ticketId].vue").then((m) => Object.assign(m.default, { __name: _91ticketId_93_ENkg_ET_nS3OaCDo0ExvXaMXtPmIHK8uW6wRL3x5awMeta?.name ?? "support-ticketId___pt" }))
  },
  {
    name: "support-ticketId___nl",
    path: "/nl/support/:ticketId()",
    component: () => import("/opt/app-root/src/website/app/pages/support/[ticketId].vue").then((m) => Object.assign(m.default, { __name: _91ticketId_93_ENkg_ET_nS3OaCDo0ExvXaMXtPmIHK8uW6wRL3x5awMeta?.name ?? "support-ticketId___nl" }))
  },
  {
    name: "support-ticketId___ja",
    path: "/ja/support/:ticketId()",
    component: () => import("/opt/app-root/src/website/app/pages/support/[ticketId].vue").then((m) => Object.assign(m.default, { __name: _91ticketId_93_ENkg_ET_nS3OaCDo0ExvXaMXtPmIHK8uW6wRL3x5awMeta?.name ?? "support-ticketId___ja" }))
  },
  {
    name: "support-ticketId___zh",
    path: "/zh/support/:ticketId()",
    component: () => import("/opt/app-root/src/website/app/pages/support/[ticketId].vue").then((m) => Object.assign(m.default, { __name: _91ticketId_93_ENkg_ET_nS3OaCDo0ExvXaMXtPmIHK8uW6wRL3x5awMeta?.name ?? "support-ticketId___zh" }))
  },
  {
    name: "debug___de",
    path: "/de/debug",
    meta: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/debug/index.vue").then((m) => Object.assign(m.default, { __name: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta?.name ?? "debug___de" }))
  },
  {
    name: "debug___en",
    path: "/en/debug",
    meta: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/debug/index.vue").then((m) => Object.assign(m.default, { __name: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta?.name ?? "debug___en" }))
  },
  {
    name: "debug___fr",
    path: "/fr/debug",
    meta: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/debug/index.vue").then((m) => Object.assign(m.default, { __name: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta?.name ?? "debug___fr" }))
  },
  {
    name: "debug___it",
    path: "/it/debug",
    meta: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/debug/index.vue").then((m) => Object.assign(m.default, { __name: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta?.name ?? "debug___it" }))
  },
  {
    name: "debug___pl",
    path: "/pl/debug",
    meta: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/debug/index.vue").then((m) => Object.assign(m.default, { __name: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta?.name ?? "debug___pl" }))
  },
  {
    name: "debug___es",
    path: "/es/debug",
    meta: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/debug/index.vue").then((m) => Object.assign(m.default, { __name: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta?.name ?? "debug___es" }))
  },
  {
    name: "debug___pt",
    path: "/pt/debug",
    meta: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/debug/index.vue").then((m) => Object.assign(m.default, { __name: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta?.name ?? "debug___pt" }))
  },
  {
    name: "debug___nl",
    path: "/nl/debug",
    meta: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/debug/index.vue").then((m) => Object.assign(m.default, { __name: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta?.name ?? "debug___nl" }))
  },
  {
    name: "debug___ja",
    path: "/ja/debug",
    meta: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/debug/index.vue").then((m) => Object.assign(m.default, { __name: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta?.name ?? "debug___ja" }))
  },
  {
    name: "debug___zh",
    path: "/zh/debug",
    meta: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/debug/index.vue").then((m) => Object.assign(m.default, { __name: indexUqtwycGIcqtwlFfD8v3rUI9ha9DVAfRaPQ3ZVdWJe7IMeta?.name ?? "debug___zh" }))
  },
  {
    name: "lootpass___de",
    path: "/de/lootpass",
    component: () => import("/opt/app-root/src/website/app/pages/lootpass/index.vue").then((m) => Object.assign(m.default, { __name: indexbRw9SBxZlBkMlsyi9aGzNV_57kwDJGkraFXS94Gu2ocMeta?.name ?? "lootpass___de" }))
  },
  {
    name: "lootpass___en",
    path: "/en/lootpass",
    component: () => import("/opt/app-root/src/website/app/pages/lootpass/index.vue").then((m) => Object.assign(m.default, { __name: indexbRw9SBxZlBkMlsyi9aGzNV_57kwDJGkraFXS94Gu2ocMeta?.name ?? "lootpass___en" }))
  },
  {
    name: "lootpass___fr",
    path: "/fr/lootpass",
    component: () => import("/opt/app-root/src/website/app/pages/lootpass/index.vue").then((m) => Object.assign(m.default, { __name: indexbRw9SBxZlBkMlsyi9aGzNV_57kwDJGkraFXS94Gu2ocMeta?.name ?? "lootpass___fr" }))
  },
  {
    name: "lootpass___it",
    path: "/it/lootpass",
    component: () => import("/opt/app-root/src/website/app/pages/lootpass/index.vue").then((m) => Object.assign(m.default, { __name: indexbRw9SBxZlBkMlsyi9aGzNV_57kwDJGkraFXS94Gu2ocMeta?.name ?? "lootpass___it" }))
  },
  {
    name: "lootpass___pl",
    path: "/pl/lootpass",
    component: () => import("/opt/app-root/src/website/app/pages/lootpass/index.vue").then((m) => Object.assign(m.default, { __name: indexbRw9SBxZlBkMlsyi9aGzNV_57kwDJGkraFXS94Gu2ocMeta?.name ?? "lootpass___pl" }))
  },
  {
    name: "lootpass___es",
    path: "/es/lootpass",
    component: () => import("/opt/app-root/src/website/app/pages/lootpass/index.vue").then((m) => Object.assign(m.default, { __name: indexbRw9SBxZlBkMlsyi9aGzNV_57kwDJGkraFXS94Gu2ocMeta?.name ?? "lootpass___es" }))
  },
  {
    name: "lootpass___pt",
    path: "/pt/lootpass",
    component: () => import("/opt/app-root/src/website/app/pages/lootpass/index.vue").then((m) => Object.assign(m.default, { __name: indexbRw9SBxZlBkMlsyi9aGzNV_57kwDJGkraFXS94Gu2ocMeta?.name ?? "lootpass___pt" }))
  },
  {
    name: "lootpass___nl",
    path: "/nl/lootpass",
    component: () => import("/opt/app-root/src/website/app/pages/lootpass/index.vue").then((m) => Object.assign(m.default, { __name: indexbRw9SBxZlBkMlsyi9aGzNV_57kwDJGkraFXS94Gu2ocMeta?.name ?? "lootpass___nl" }))
  },
  {
    name: "lootpass___ja",
    path: "/ja/lootpass",
    component: () => import("/opt/app-root/src/website/app/pages/lootpass/index.vue").then((m) => Object.assign(m.default, { __name: indexbRw9SBxZlBkMlsyi9aGzNV_57kwDJGkraFXS94Gu2ocMeta?.name ?? "lootpass___ja" }))
  },
  {
    name: "lootpass___zh",
    path: "/zh/lootpass",
    component: () => import("/opt/app-root/src/website/app/pages/lootpass/index.vue").then((m) => Object.assign(m.default, { __name: indexbRw9SBxZlBkMlsyi9aGzNV_57kwDJGkraFXS94Gu2ocMeta?.name ?? "lootpass___zh" }))
  },
  {
    name: "news___de",
    path: "/de/news",
    component: () => import("/opt/app-root/src/website/app/pages/news/index.vue").then((m) => Object.assign(m.default, { __name: indexbUsI8ZTOiTNGgQdx_3HPSloMW_NhCFvCERS6W1zYnckMeta?.name ?? "news___de" }))
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("/opt/app-root/src/website/app/pages/news/index.vue").then((m) => Object.assign(m.default, { __name: indexbUsI8ZTOiTNGgQdx_3HPSloMW_NhCFvCERS6W1zYnckMeta?.name ?? "news___en" }))
  },
  {
    name: "news___fr",
    path: "/fr/news",
    component: () => import("/opt/app-root/src/website/app/pages/news/index.vue").then((m) => Object.assign(m.default, { __name: indexbUsI8ZTOiTNGgQdx_3HPSloMW_NhCFvCERS6W1zYnckMeta?.name ?? "news___fr" }))
  },
  {
    name: "news___it",
    path: "/it/news",
    component: () => import("/opt/app-root/src/website/app/pages/news/index.vue").then((m) => Object.assign(m.default, { __name: indexbUsI8ZTOiTNGgQdx_3HPSloMW_NhCFvCERS6W1zYnckMeta?.name ?? "news___it" }))
  },
  {
    name: "news___pl",
    path: "/pl/news",
    component: () => import("/opt/app-root/src/website/app/pages/news/index.vue").then((m) => Object.assign(m.default, { __name: indexbUsI8ZTOiTNGgQdx_3HPSloMW_NhCFvCERS6W1zYnckMeta?.name ?? "news___pl" }))
  },
  {
    name: "news___es",
    path: "/es/news",
    component: () => import("/opt/app-root/src/website/app/pages/news/index.vue").then((m) => Object.assign(m.default, { __name: indexbUsI8ZTOiTNGgQdx_3HPSloMW_NhCFvCERS6W1zYnckMeta?.name ?? "news___es" }))
  },
  {
    name: "news___pt",
    path: "/pt/news",
    component: () => import("/opt/app-root/src/website/app/pages/news/index.vue").then((m) => Object.assign(m.default, { __name: indexbUsI8ZTOiTNGgQdx_3HPSloMW_NhCFvCERS6W1zYnckMeta?.name ?? "news___pt" }))
  },
  {
    name: "news___nl",
    path: "/nl/news",
    component: () => import("/opt/app-root/src/website/app/pages/news/index.vue").then((m) => Object.assign(m.default, { __name: indexbUsI8ZTOiTNGgQdx_3HPSloMW_NhCFvCERS6W1zYnckMeta?.name ?? "news___nl" }))
  },
  {
    name: "news___ja",
    path: "/ja/news",
    component: () => import("/opt/app-root/src/website/app/pages/news/index.vue").then((m) => Object.assign(m.default, { __name: indexbUsI8ZTOiTNGgQdx_3HPSloMW_NhCFvCERS6W1zYnckMeta?.name ?? "news___ja" }))
  },
  {
    name: "news___zh",
    path: "/zh/news",
    component: () => import("/opt/app-root/src/website/app/pages/news/index.vue").then((m) => Object.assign(m.default, { __name: indexbUsI8ZTOiTNGgQdx_3HPSloMW_NhCFvCERS6W1zYnckMeta?.name ?? "news___zh" }))
  },
  {
    name: "partner___de",
    path: "/de/partner",
    component: () => import("/opt/app-root/src/website/app/pages/partner/index.vue").then((m) => Object.assign(m.default, { __name: indexMkCycdtl_JjCrmp_M7srDRO2ZAVRrW_AGv1yIos0JXQMeta?.name ?? "partner___de" }))
  },
  {
    name: "partner___en",
    path: "/en/partner",
    component: () => import("/opt/app-root/src/website/app/pages/partner/index.vue").then((m) => Object.assign(m.default, { __name: indexMkCycdtl_JjCrmp_M7srDRO2ZAVRrW_AGv1yIos0JXQMeta?.name ?? "partner___en" }))
  },
  {
    name: "partner___fr",
    path: "/fr/partner",
    component: () => import("/opt/app-root/src/website/app/pages/partner/index.vue").then((m) => Object.assign(m.default, { __name: indexMkCycdtl_JjCrmp_M7srDRO2ZAVRrW_AGv1yIos0JXQMeta?.name ?? "partner___fr" }))
  },
  {
    name: "partner___it",
    path: "/it/partner",
    component: () => import("/opt/app-root/src/website/app/pages/partner/index.vue").then((m) => Object.assign(m.default, { __name: indexMkCycdtl_JjCrmp_M7srDRO2ZAVRrW_AGv1yIos0JXQMeta?.name ?? "partner___it" }))
  },
  {
    name: "partner___pl",
    path: "/pl/partner",
    component: () => import("/opt/app-root/src/website/app/pages/partner/index.vue").then((m) => Object.assign(m.default, { __name: indexMkCycdtl_JjCrmp_M7srDRO2ZAVRrW_AGv1yIos0JXQMeta?.name ?? "partner___pl" }))
  },
  {
    name: "partner___es",
    path: "/es/partner",
    component: () => import("/opt/app-root/src/website/app/pages/partner/index.vue").then((m) => Object.assign(m.default, { __name: indexMkCycdtl_JjCrmp_M7srDRO2ZAVRrW_AGv1yIos0JXQMeta?.name ?? "partner___es" }))
  },
  {
    name: "partner___pt",
    path: "/pt/partner",
    component: () => import("/opt/app-root/src/website/app/pages/partner/index.vue").then((m) => Object.assign(m.default, { __name: indexMkCycdtl_JjCrmp_M7srDRO2ZAVRrW_AGv1yIos0JXQMeta?.name ?? "partner___pt" }))
  },
  {
    name: "partner___nl",
    path: "/nl/partner",
    component: () => import("/opt/app-root/src/website/app/pages/partner/index.vue").then((m) => Object.assign(m.default, { __name: indexMkCycdtl_JjCrmp_M7srDRO2ZAVRrW_AGv1yIos0JXQMeta?.name ?? "partner___nl" }))
  },
  {
    name: "partner___ja",
    path: "/ja/partner",
    component: () => import("/opt/app-root/src/website/app/pages/partner/index.vue").then((m) => Object.assign(m.default, { __name: indexMkCycdtl_JjCrmp_M7srDRO2ZAVRrW_AGv1yIos0JXQMeta?.name ?? "partner___ja" }))
  },
  {
    name: "partner___zh",
    path: "/zh/partner",
    component: () => import("/opt/app-root/src/website/app/pages/partner/index.vue").then((m) => Object.assign(m.default, { __name: indexMkCycdtl_JjCrmp_M7srDRO2ZAVRrW_AGv1yIos0JXQMeta?.name ?? "partner___zh" }))
  },
  {
    name: "profile___de",
    path: "/de/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/profile/index.vue").then((m) => Object.assign(m.default, { __name: indexwDx9q12sAr29piTqQrjzKdc8jL7CP7UXqNxj3Iq2Mx4Meta?.name ?? "profile___de" }))
  },
  {
    name: "profile___en",
    path: "/en/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/profile/index.vue").then((m) => Object.assign(m.default, { __name: indexwDx9q12sAr29piTqQrjzKdc8jL7CP7UXqNxj3Iq2Mx4Meta?.name ?? "profile___en" }))
  },
  {
    name: "profile___fr",
    path: "/fr/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/profile/index.vue").then((m) => Object.assign(m.default, { __name: indexwDx9q12sAr29piTqQrjzKdc8jL7CP7UXqNxj3Iq2Mx4Meta?.name ?? "profile___fr" }))
  },
  {
    name: "profile___it",
    path: "/it/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/profile/index.vue").then((m) => Object.assign(m.default, { __name: indexwDx9q12sAr29piTqQrjzKdc8jL7CP7UXqNxj3Iq2Mx4Meta?.name ?? "profile___it" }))
  },
  {
    name: "profile___pl",
    path: "/pl/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/profile/index.vue").then((m) => Object.assign(m.default, { __name: indexwDx9q12sAr29piTqQrjzKdc8jL7CP7UXqNxj3Iq2Mx4Meta?.name ?? "profile___pl" }))
  },
  {
    name: "profile___es",
    path: "/es/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/profile/index.vue").then((m) => Object.assign(m.default, { __name: indexwDx9q12sAr29piTqQrjzKdc8jL7CP7UXqNxj3Iq2Mx4Meta?.name ?? "profile___es" }))
  },
  {
    name: "profile___pt",
    path: "/pt/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/profile/index.vue").then((m) => Object.assign(m.default, { __name: indexwDx9q12sAr29piTqQrjzKdc8jL7CP7UXqNxj3Iq2Mx4Meta?.name ?? "profile___pt" }))
  },
  {
    name: "profile___nl",
    path: "/nl/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/profile/index.vue").then((m) => Object.assign(m.default, { __name: indexwDx9q12sAr29piTqQrjzKdc8jL7CP7UXqNxj3Iq2Mx4Meta?.name ?? "profile___nl" }))
  },
  {
    name: "profile___ja",
    path: "/ja/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/profile/index.vue").then((m) => Object.assign(m.default, { __name: indexwDx9q12sAr29piTqQrjzKdc8jL7CP7UXqNxj3Iq2Mx4Meta?.name ?? "profile___ja" }))
  },
  {
    name: "profile___zh",
    path: "/zh/profile",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/app-root/src/website/variants/legacy/app/pages/profile/index.vue").then((m) => Object.assign(m.default, { __name: indexwDx9q12sAr29piTqQrjzKdc8jL7CP7UXqNxj3Iq2Mx4Meta?.name ?? "profile___zh" }))
  },
  {
    name: "register___de",
    path: "/de/register",
    meta: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/register/index.vue").then((m) => Object.assign(m.default, { __name: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta?.name ?? "register___de" }))
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/register/index.vue").then((m) => Object.assign(m.default, { __name: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta?.name ?? "register___en" }))
  },
  {
    name: "register___fr",
    path: "/fr/register",
    meta: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/register/index.vue").then((m) => Object.assign(m.default, { __name: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta?.name ?? "register___fr" }))
  },
  {
    name: "register___it",
    path: "/it/register",
    meta: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/register/index.vue").then((m) => Object.assign(m.default, { __name: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta?.name ?? "register___it" }))
  },
  {
    name: "register___pl",
    path: "/pl/register",
    meta: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/register/index.vue").then((m) => Object.assign(m.default, { __name: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta?.name ?? "register___pl" }))
  },
  {
    name: "register___es",
    path: "/es/register",
    meta: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/register/index.vue").then((m) => Object.assign(m.default, { __name: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta?.name ?? "register___es" }))
  },
  {
    name: "register___pt",
    path: "/pt/register",
    meta: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/register/index.vue").then((m) => Object.assign(m.default, { __name: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta?.name ?? "register___pt" }))
  },
  {
    name: "register___nl",
    path: "/nl/register",
    meta: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/register/index.vue").then((m) => Object.assign(m.default, { __name: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta?.name ?? "register___nl" }))
  },
  {
    name: "register___ja",
    path: "/ja/register",
    meta: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/register/index.vue").then((m) => Object.assign(m.default, { __name: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta?.name ?? "register___ja" }))
  },
  {
    name: "register___zh",
    path: "/zh/register",
    meta: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta || {},
    component: () => import("/opt/app-root/src/website/app/pages/register/index.vue").then((m) => Object.assign(m.default, { __name: indexN7r7C6djwQ1sbWScS2t8GXqwtC8YJ41K8q1GflYRxxQMeta?.name ?? "register___zh" }))
  },
  {
    name: "support___de",
    path: "/de/support",
    component: () => import("/opt/app-root/src/website/app/pages/support/index.vue").then((m) => Object.assign(m.default, { __name: index4hkRRR5YsmCzyK0BATYUNo_N2DeBR9RdEc1_FUqh7zoMeta?.name ?? "support___de" }))
  },
  {
    name: "support___en",
    path: "/en/support",
    component: () => import("/opt/app-root/src/website/app/pages/support/index.vue").then((m) => Object.assign(m.default, { __name: index4hkRRR5YsmCzyK0BATYUNo_N2DeBR9RdEc1_FUqh7zoMeta?.name ?? "support___en" }))
  },
  {
    name: "support___fr",
    path: "/fr/support",
    component: () => import("/opt/app-root/src/website/app/pages/support/index.vue").then((m) => Object.assign(m.default, { __name: index4hkRRR5YsmCzyK0BATYUNo_N2DeBR9RdEc1_FUqh7zoMeta?.name ?? "support___fr" }))
  },
  {
    name: "support___it",
    path: "/it/support",
    component: () => import("/opt/app-root/src/website/app/pages/support/index.vue").then((m) => Object.assign(m.default, { __name: index4hkRRR5YsmCzyK0BATYUNo_N2DeBR9RdEc1_FUqh7zoMeta?.name ?? "support___it" }))
  },
  {
    name: "support___pl",
    path: "/pl/support",
    component: () => import("/opt/app-root/src/website/app/pages/support/index.vue").then((m) => Object.assign(m.default, { __name: index4hkRRR5YsmCzyK0BATYUNo_N2DeBR9RdEc1_FUqh7zoMeta?.name ?? "support___pl" }))
  },
  {
    name: "support___es",
    path: "/es/support",
    component: () => import("/opt/app-root/src/website/app/pages/support/index.vue").then((m) => Object.assign(m.default, { __name: index4hkRRR5YsmCzyK0BATYUNo_N2DeBR9RdEc1_FUqh7zoMeta?.name ?? "support___es" }))
  },
  {
    name: "support___pt",
    path: "/pt/support",
    component: () => import("/opt/app-root/src/website/app/pages/support/index.vue").then((m) => Object.assign(m.default, { __name: index4hkRRR5YsmCzyK0BATYUNo_N2DeBR9RdEc1_FUqh7zoMeta?.name ?? "support___pt" }))
  },
  {
    name: "support___nl",
    path: "/nl/support",
    component: () => import("/opt/app-root/src/website/app/pages/support/index.vue").then((m) => Object.assign(m.default, { __name: index4hkRRR5YsmCzyK0BATYUNo_N2DeBR9RdEc1_FUqh7zoMeta?.name ?? "support___nl" }))
  },
  {
    name: "support___ja",
    path: "/ja/support",
    component: () => import("/opt/app-root/src/website/app/pages/support/index.vue").then((m) => Object.assign(m.default, { __name: index4hkRRR5YsmCzyK0BATYUNo_N2DeBR9RdEc1_FUqh7zoMeta?.name ?? "support___ja" }))
  },
  {
    name: "support___zh",
    path: "/zh/support",
    component: () => import("/opt/app-root/src/website/app/pages/support/index.vue").then((m) => Object.assign(m.default, { __name: index4hkRRR5YsmCzyK0BATYUNo_N2DeBR9RdEc1_FUqh7zoMeta?.name ?? "support___zh" }))
  },
  {
    name: "sustainability___de",
    path: "/de/sustainability",
    component: () => import("/opt/app-root/src/website/app/pages/sustainability/index.vue").then((m) => Object.assign(m.default, { __name: indexV9gLKo3fojB2xfh_g_YRQgKXawLgnQF15Vr1RQ7brrgMeta?.name ?? "sustainability___de" }))
  },
  {
    name: "sustainability___en",
    path: "/en/sustainability",
    component: () => import("/opt/app-root/src/website/app/pages/sustainability/index.vue").then((m) => Object.assign(m.default, { __name: indexV9gLKo3fojB2xfh_g_YRQgKXawLgnQF15Vr1RQ7brrgMeta?.name ?? "sustainability___en" }))
  },
  {
    name: "sustainability___fr",
    path: "/fr/sustainability",
    component: () => import("/opt/app-root/src/website/app/pages/sustainability/index.vue").then((m) => Object.assign(m.default, { __name: indexV9gLKo3fojB2xfh_g_YRQgKXawLgnQF15Vr1RQ7brrgMeta?.name ?? "sustainability___fr" }))
  },
  {
    name: "sustainability___it",
    path: "/it/sustainability",
    component: () => import("/opt/app-root/src/website/app/pages/sustainability/index.vue").then((m) => Object.assign(m.default, { __name: indexV9gLKo3fojB2xfh_g_YRQgKXawLgnQF15Vr1RQ7brrgMeta?.name ?? "sustainability___it" }))
  },
  {
    name: "sustainability___pl",
    path: "/pl/sustainability",
    component: () => import("/opt/app-root/src/website/app/pages/sustainability/index.vue").then((m) => Object.assign(m.default, { __name: indexV9gLKo3fojB2xfh_g_YRQgKXawLgnQF15Vr1RQ7brrgMeta?.name ?? "sustainability___pl" }))
  },
  {
    name: "sustainability___es",
    path: "/es/sustainability",
    component: () => import("/opt/app-root/src/website/app/pages/sustainability/index.vue").then((m) => Object.assign(m.default, { __name: indexV9gLKo3fojB2xfh_g_YRQgKXawLgnQF15Vr1RQ7brrgMeta?.name ?? "sustainability___es" }))
  },
  {
    name: "sustainability___pt",
    path: "/pt/sustainability",
    component: () => import("/opt/app-root/src/website/app/pages/sustainability/index.vue").then((m) => Object.assign(m.default, { __name: indexV9gLKo3fojB2xfh_g_YRQgKXawLgnQF15Vr1RQ7brrgMeta?.name ?? "sustainability___pt" }))
  },
  {
    name: "sustainability___nl",
    path: "/nl/sustainability",
    component: () => import("/opt/app-root/src/website/app/pages/sustainability/index.vue").then((m) => Object.assign(m.default, { __name: indexV9gLKo3fojB2xfh_g_YRQgKXawLgnQF15Vr1RQ7brrgMeta?.name ?? "sustainability___nl" }))
  },
  {
    name: "sustainability___ja",
    path: "/ja/sustainability",
    component: () => import("/opt/app-root/src/website/app/pages/sustainability/index.vue").then((m) => Object.assign(m.default, { __name: indexV9gLKo3fojB2xfh_g_YRQgKXawLgnQF15Vr1RQ7brrgMeta?.name ?? "sustainability___ja" }))
  },
  {
    name: "sustainability___zh",
    path: "/zh/sustainability",
    component: () => import("/opt/app-root/src/website/app/pages/sustainability/index.vue").then((m) => Object.assign(m.default, { __name: indexV9gLKo3fojB2xfh_g_YRQgKXawLgnQF15Vr1RQ7brrgMeta?.name ?? "sustainability___zh" }))
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/opt/app-root/src/website/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: index_NI3B_6RlcMcQC3fcUBr_RmgvQZmWgEjQPq9_onR28oMeta?.name ?? "index___de" }))
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/app-root/src/website/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: index_NI3B_6RlcMcQC3fcUBr_RmgvQZmWgEjQPq9_onR28oMeta?.name ?? "index___en" }))
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/opt/app-root/src/website/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: index_NI3B_6RlcMcQC3fcUBr_RmgvQZmWgEjQPq9_onR28oMeta?.name ?? "index___fr" }))
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/opt/app-root/src/website/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: index_NI3B_6RlcMcQC3fcUBr_RmgvQZmWgEjQPq9_onR28oMeta?.name ?? "index___it" }))
  },
  {
    name: "index___pl",
    path: "/pl",
    component: () => import("/opt/app-root/src/website/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: index_NI3B_6RlcMcQC3fcUBr_RmgvQZmWgEjQPq9_onR28oMeta?.name ?? "index___pl" }))
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/opt/app-root/src/website/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: index_NI3B_6RlcMcQC3fcUBr_RmgvQZmWgEjQPq9_onR28oMeta?.name ?? "index___es" }))
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/opt/app-root/src/website/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: index_NI3B_6RlcMcQC3fcUBr_RmgvQZmWgEjQPq9_onR28oMeta?.name ?? "index___pt" }))
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/opt/app-root/src/website/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: index_NI3B_6RlcMcQC3fcUBr_RmgvQZmWgEjQPq9_onR28oMeta?.name ?? "index___nl" }))
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("/opt/app-root/src/website/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: index_NI3B_6RlcMcQC3fcUBr_RmgvQZmWgEjQPq9_onR28oMeta?.name ?? "index___ja" }))
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/opt/app-root/src/website/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: index_NI3B_6RlcMcQC3fcUBr_RmgvQZmWgEjQPq9_onR28oMeta?.name ?? "index___zh" }))
  }
]